var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96 -436) translate(0 401) translate(0 27) translate(24 8.5) translate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6185A",
    d: "M11 22C4.924 22 0 17.076 0 11S4.924 0 11 0s11 4.924 11 11-4.924 11-11 11z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 5,
    y: 10,
    fill: "#FFF",
    rx: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClearIcon);
export default __webpack_public_path__ + "static/media/btn_clear_icon.5ea148e67059dd0d99c6ad4d478a4a6d.svg";
export { ForwardRef as ReactComponent };